import { createSlice } from "@reduxjs/toolkit";
import { createDynamicThunk } from "../../../service/requestHandler.js";

const API_Prefix = "/report/api/v1/sbom";

// -------- POST --------
export const OpenSBOMchartAPI = createDynamicThunk(
  "post/OpenSBOMchartAPI",
  API_Prefix + "/getOpenFindingsCount"
);

export const DistributionSBOMAPI = createDynamicThunk(
  "post/DistributionSBOMAPI",
  API_Prefix + "/severityDistribution"
);

export const ClosedSBOMchartAPI = createDynamicThunk(
  "post/ClosedSBOMchartAPI",
  API_Prefix + "/getClosedFindingsCount"
);

export const ActionbyplanSBOMAPI = createDynamicThunk(
  "post/ActionbyplanSBOMAPI",
  API_Prefix + "/getStatusBySeverity"
);

export const AppCriticalitySBOMAPI = createDynamicThunk(
  "post/AppCriticalitySBOMAPI",
  API_Prefix + "/getCriticalityWiseCount"
);

export const TargetDateMissedSBOMAPI = createDynamicThunk(
  "post/TargetDateMissedSBOMAPI",
  API_Prefix + "/targetdateMissed"
);

export const TargetDateDueTrendSBOMAPI = createDynamicThunk(
  "post/TargetDateDueTrendSBOMAPI",
  API_Prefix + "/targetDateDue"
);

export const SBOMTableListAPI = createDynamicThunk(
  "post/SBOMTableListAPI",
  API_Prefix + "/currentFindings/list",
  ["pageNumber", "itemsPerPage"]
);

export const SBOMTableManageAPI = createDynamicThunk(
  "post/SBOMTableManageAPI","",
  ["URL"]
);

export const SBOMFixedTableListAPI = createDynamicThunk(
  "post/SBOMFixedTableListAPI",
  API_Prefix + "/fixedFindings/list",
  ["pageNumber", "itemsPerPage"]
);

export const vulnerabilityIdDetails = createDynamicThunk(
  "post/vulnerabilityIdDetails",
  API_Prefix + "/getVulIdDetails",
  ["vulnerabilityId"],
  "GET"
);
export const vulnerabilityAffectedFiles = createDynamicThunk(
  "post/drillDownAffectedFilesFromGitlab",
  API_Prefix + "/drillDownAffectedFilesFromGitlab/",
  ["vulnerabilityId", "page", "size"]
);

export const DetailsSBOMApi = createDynamicThunk(
  "post/DetailsSBOMApi",
  API_Prefix + "/comments",
  ["id"],
  "GET"
);

export const BasescorematricsSBOMApi = createDynamicThunk(
  "post/BasescorematricsSBOMApi",
  API_Prefix + "/getBaseScoreMetricsDetails",
  ["id"]
);

// ---- State ----
const initialState = {
  OpenSBOMData: [],
  OpenSBOMDataLoading: false,

  DistributionSBOMData: [],
  DistributionSBOMDataLoading: false,

  closedSBOMData: [],
  closedSBOMDataLoading: false,

  ActionbyplanSBOMData: [],
  ActionbyplanSBOMDataLoading: false,

  AppCriticalitySBOMData: [],
  AppCriticalitySBOMDataLoading: false,

  TargetDateMissedSBOMData: [],
  TargetDateMissedSBOMDataLoading: false,

  TargetDateDueTrendSBOMData: [],
  TargetDateDueTrendSBOMDataLoading: false,

  SBOMTableData: [],
  SBOMTableDataLoading: false,

  SBOMTableManageData: [],
  SBOMTableManageLoading: false,

  SBOMFixedTableData: [],
  SBOMFixedTableDataLoading: false,

  vulnerabilityIdDetailsData: [],
  vulnerabilityIdDetailsLoading: false,

  vulnerabilityAffectedFilesData: [],
  vulnerabilityAffectedFilesLoading: false,

  DetailsData: [],
  DetailsDataLoading: false,

  BasescoreData: [],
  BasescoreLoading: false,
};

// ---- Case Reducer Helper ----
const addApiCases = (builder, thunk, stateKey, isDelete = false) => {
  builder
    .addCase(thunk.pending, (state) => {
      state[`${stateKey}Loading`] = true;
    })
    .addCase(thunk.fulfilled, (state, action) => {
      state[`${stateKey}Loading`] = false;
      if (isDelete) {
        // for delete method ,don't need to check with data
        state[stateKey] = action.payload;
      } else {
        state[stateKey] = action.payload ?? [];
      }
    })
    .addCase(thunk.rejected, (state) => {
      state[`${stateKey}Loading`] = false;
      if (isDelete) {
        state.errorDelete = "Something went wrong";
      } else {
        state[stateKey] = [];
      }
    });
};

export const SBOMSlice = createSlice({
  name: "SBOMSlice",
  initialState,
  reducers: {
    resetSBOMData: () => {
      return initialState;
    },
    setDisabledCategories: (state, action) => {
      state.disabledCategories = action.payload;
    },
  },
  extraReducers: (builder) => {
    // POST
    addApiCases(builder, OpenSBOMchartAPI, "OpenSBOMData");
    addApiCases(builder, DistributionSBOMAPI, "DistributionSBOMData");
    addApiCases(builder, ClosedSBOMchartAPI, "closedSBOMData");
    addApiCases(builder, ActionbyplanSBOMAPI, "ActionbyplanSBOMData");
    addApiCases(builder, AppCriticalitySBOMAPI, "AppCriticalitySBOMData");
    addApiCases(builder, TargetDateMissedSBOMAPI, "TargetDateMissedSBOMData");
    addApiCases(
      builder,
      TargetDateDueTrendSBOMAPI,
      "TargetDateDueTrendSBOMData"
    );
    addApiCases(builder, SBOMTableListAPI, "SBOMTableData");
    addApiCases(builder, SBOMTableManageAPI, "SBOMTableManageData");
    addApiCases(builder, SBOMFixedTableListAPI, "SBOMFixedTableData");
    addApiCases(builder, vulnerabilityIdDetails, "vulnerabilityIdDetailsData");
    addApiCases(
      builder,
      vulnerabilityAffectedFiles,
      "vulnerabilityAffectedFilesData"
    );
    addApiCases(builder, DetailsSBOMApi, "DetailsData");
    addApiCases(builder, BasescorematricsSBOMApi, "BasescoreData");
  },
});
 
export const { resetSBOMData, setDisabledCategories } = SBOMSlice.actions;
export default SBOMSlice.reducer;